import React from 'react';

function Masters() {
  return (
    <div>
      <h2>Masters</h2>
    </div>
  );
}

export default Masters;
